import React, { useState, useEffect } from "react";
import * as api from "../../services/api/admin";
import SelectBase from "./SelectBase";

const SelectJobTitle: React.FC<SelectType<JobTitleProps>> = props => {
  const [items, setItems] = useState<Array<JobTitleProps>>([]);

  const getItems = () => {
    api.getJobTitles().then(({ data }) => setItems(data));
  };

  useEffect(() => {
    getItems();
  }, []);

  const options = () => {
    return items
      .sort((a, b) => {
        return a.name.localeCompare(b.name);
      })
      .map(item => ({
        value: item.id,
        label: item.name
      }));
  };

  return (
    <SelectBase
      placeholder="Função..."
      options={options()}
      getItems={getItems}
      onClick={props.onChange}
      newItem={props.newItem}
      updatedItem={props.updatedItem}
      deletedItem={props.deletedItem}
      {...props}
    />
  );
};

export default SelectJobTitle;
